import { API } from "aws-amplify";
import "containers/common/List.css";
import React, { Component } from "react";
import { Alert, Button, Col, Form, ListGroup, Modal, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import { LinkContainer } from "react-router-bootstrap";
import Select from 'react-select';
import ReactTable from "react-table";


export default class PropertyAddList extends Component {
    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            isLoading: true,
            filter: {},
            data: [],
            
            dataSet: "properties",
            dataRecord: "properties",
            dataSetPrimaryKey: "property_id",
            showAlert: false,
            errorMessage: "",
            savingNewRecord: false
        };

        
    }
    

    async componentDidMount() {
        this.setState({ isLoading: true });     
        if (!this.props.isAuthenticated) { // if false
            return;
        }        

        if(this.props.data){
            const data = this.props.data;
            this.setState({ data });
        }
        this.setState({ isLoading: false });      
    }

    componentDidUpdate(prevProps) {

        if (this.props.data !== prevProps.data) {
            const data = this.props.data;
            this.setState({ data });
        }

    }


    async handleDataSave(data) {
        try {
            return await this.saveRecord(data, this.state.dataSet, this.state.dataSetPrimaryKey);



        } catch (e) {
            alert("Error saving");
        }
    }

    saveRecord(record, endpoint, id) {
        
        record.last_edited_by= this.props.user;
        //If the record is a new record perform a post
        if (record.hasOwnProperty("new_record")) {
            if (record.new_record === true) {
                               
                return API.post("colin", `/properties/new`, {
                    body: record
                });
                
                
            }
        }
        
        return API.put("colin", `/properties/${record[id]}`, {
            body: record
        });
            
       

       
    }




    handleCopyRecord = async (cellInfo, event) => {
        event.preventDefault();
        console.log("Copy record");
        let data = [...this.state.data];
        
        let copiedProperty = data[cellInfo.index];
        let newProperty = {
                            cityscope: copiedProperty.cityscope,
                            map_number: copiedProperty.map_number,
                            map_number_suffix: copiedProperty.map_number_suffix,
                            property_number: copiedProperty.property_number,
                            property_number_suffix: copiedProperty.property_number_suffix,
                            unit_number: copiedProperty.unit_number,
                            unit_number_suffix: copiedProperty.unit_number_suffix,
                            unit_sort: copiedProperty.unit_sort,
                            parking_yes_no: copiedProperty.parking_yes_no,
                            suburb: copiedProperty.suburb,
                            state: copiedProperty.state,
                            postcode: copiedProperty.postcode,
                            bedrooms: copiedProperty.bedrooms,
                            unit_area: copiedProperty.unit_area,
                            unit_level_number: copiedProperty.unit_level_number,
                            description: copiedProperty.description,
                            created_by: this.props.user,     
                            last_edited_by: this.props.user,
                            new_record: true,
                            property_id: null,
                            origin_db: null,
                            parking_num: null,
                            typical_floor_area: null,
                            storeys: null,
                            building_area: null,
                            year_built: null,
                            year_refurb: null,
                            site_area: null,
                            entity_id_managing_agent: null,
                            managing_agent: null,
                            historical_listings: null,
                            sales_text: null,
                            frontages_text: null,
                            zoning_text: copiedProperty.zoning_text,
                            title_details: copiedProperty.title_details,
                            valuations_text: null,
                            sales_notes: null,
                            description_notes: null,
                            owner_notes: null,
                            frontages_notes: null,
                            occupants_notes: null,
                            historical_notes: null,
                            title_notes: null,
                            valuations_notes: null,
                            occupants_preamble: null,
                            occupants_postamble: null,
                            owner_preamble: null,
                            owner_postamble: null,
                            for_sale_line: null,
                            nla_date: null,
                            lease_term: null,
                            description_postamble: null,
                            sales_history_postamble: null,
                            entity_contact_id_managing_agent: null,
                            managing_agent_contact: null,
                            internet: null,
                            email: null,
                            photo_required: false,
                            photo_why: null,
                            leasing_notes: null,
                            title_last_searched: null,         
                            sub_divided_unit: false,
                            auto_doors: null,
                            created_date: null,
                            last_edited_date: null
                                        };
        
        
        data.push(newProperty);
                   
        this.updateTableState(data, this.state.dataSet);
       
        
    };

    updateTableState(data, set) {
        
        this.setState({
            data
        });
    }

    handleInputChange = (cellInfo, event) => {
        console.log(typeof (event.target.value));
        let data = [...this.state.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.value;
        data[cellInfo.index].modified = true;
        this.updateTableState(data, this.state.dataSet);
    };
    handleNumberChange = (cellInfo, event) => {
        let data = [...this.state.data];
        let val = event.target.value.replace(/[^0-9.]/g, "");
        
        data[cellInfo.index][cellInfo.column.id] = Number(val);
        data[cellInfo.index].modified = true;
        this.updateTableState(data, this.state.dataSet);
    };
    handleCheckboxChange = (cellInfo, event) => {
        let data = [...this.state.data];
        data[cellInfo.index][cellInfo.column.id] = event.target.checked;
        data[cellInfo.index].modified = true;
        this.updateTableState(data, this.state.dataSet);
    };

    handleDateChange = (cellInfo, event) => {
        let data = [...this.state.data];
        data[cellInfo.index][cellInfo.column.id] = new Date(event);
        data[cellInfo.index].modified = true;
        this.updateTableState(data, this.state.dataSet);

    }

    handleSuburbChange = (cellInfo, event) => {
        let data = [...this.state.data];
        console.log(event);
        data[cellInfo.index].suburb = event.suburb;
        data[cellInfo.index].postcode = event.postcode;
        data[cellInfo.index].state = event.state;

        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }

    handleCityscopeChange = (cellInfo, event) => {
        let data = [...this.state.data];
        console.log(event);
        data[cellInfo.index][cellInfo.column.id] = event.value;


        data[cellInfo.index].modified = true;
        this.props.updateTableState(data, this.state.dataSet);

    }


    async buildPropertyKey(property) {
        let property_key = property.cityscope + (property.map_number || "").toString() + (property.map_number_suffix || "") + "." + (property.property_number || "").toString() + (property.property_number_suffix || "");

        if (property.unit_number !=="" && property.unit_number !== null) {
            property_key = property_key + "." + (property.unit_number.toString() | "") + (property.unit_number_suffix || "")
        }
        
        return property_key;
    }

    validateRelatedRecord(record, set) {

         //Property Validation
         if (set === "properties") {
            
            if(this.props.propertyid){
                if (record.property_id == this.props.propertyid) {                

                    return [true, "You cannot edit the original record"];
                    
                }
            }
        }
        return [true,];
    }
    
    handleSave = async (cellInfo, event) => {

        this.setState({ showAlert: false });
        let data = [...this.state.data];
        for (var i=0; i<data.length; i++){
            
            data[i].property_key = await this.buildPropertyKey(data[i]);
            
            const validation = this.validateRelatedRecord(data[i], this.state.dataSet);
            console.log(validation[0]);
            console.log(validation[1]);
            if (validation[0] === true) {
                if (data[i].hasOwnProperty("modified")) {
                    if (data[i].modified === true) {
                        console.log(i);
                        //Save the data
                        if (!this.state.savingNewRecord) {
                            if (data[i].hasOwnProperty("new_record")) {
                                if (data[i].new_record === true) {
                                    this.setState({ savingNewRecord: true });
                                }
                            }
                            data[i].force=true;
                            const result = await this.handleDataSave(data[i]);
                            if (result.result) {
                                data[i].modified = false;
                                if (data[i].hasOwnProperty("new_record")) {
                                    if (data[i].new_record === true) {

                                        data[i][this.state.dataSetPrimaryKey] = result.id;
                                        this.setState({ savingNewRecord: false });
                                    }
                                    data[i].new_record = false;
                                }
                                                               
                            }
                            else {
                                this.setState({ errorMessage: result.error_message });
                                this.setState({ showAlert: true });
                                this.setState({ savingNewRecord: false });
                            }
                        }
                    }

                }
            }
            else {
                this.setState({ errorMessage: validation[1] });
                this.setState({ showAlert: true });
                return;
            }
        }   
        if (data[0].hasOwnProperty("sort_order")) {
            data.sort(function (a, b) { return a.sort_order - b.sort_order });
        }
        this.updateTableState(data, this.state.dataSet);

    }


    addRecord = async event => {
        let data = [...this.state.data];

        //Update the following with the minimum details to create a record (all not nulls populated)
        //Requires updating per dataset
        data.push({
                            cityscope: "",
                            map_number: "",
                            map_number_suffix: "",
                            property_number: "",
                            property_number_suffix: "",
                            unit_number: "",
                            unit_number_suffix: "",
                            unit_sort: "",
                            parking_yes_no: "",
                            suburb: "",
                            state: "",
                            postcode: "",
                            bedrooms: null,
                            unit_area: null,
                            unit_level_number: null,
                            description: "",
                            created_by: this.props.user,     
                            last_edited_by: this.props.user,
                            new_record: true,
                            property_id: null,
                            origin_db: null,
                            parking_num: null,
                            typical_floor_area: null,
                            storeys: null,
                            building_area: null,
                            year_built: null,
                            year_refurb: null,
                            site_area: null,
                            entity_id_managing_agent: null,
                            managing_agent: null,
                            historical_listings: null,
                            sales_text: null,
                            frontages_text: null,
                            zoning_text: null,
                            valuations_text: null,
                            sales_notes: null,
                            description_notes: null,
                            owner_notes: null,
                            frontages_notes: null,
                            occupants_notes: null,
                            historical_notes: null,
                            title_notes: null,
                            valuations_notes: null,
                            occupants_preamble: null,
                            occupants_postamble: null,
                            owner_preamble: null,
                            owner_postamble: null,
                            for_sale_line: null,
                            nla_date: null,
                            lease_term: null,
                            description_postamble: null,
                            sales_history_postamble: null,
                            entity_contact_id_managing_agent: null,
                            managing_agent_contact: null,
                            internet: null,
                            email: null,
                            photo_required: false,
                            photo_why: null,
                            leasing_notes: null,
                            title_last_searched: null,         
                            sub_divided_unit: false,
                            auto_doors: null,
                            created_date: null,
                            last_edited_date: null

        });
        this.updateTableState(data, this.state.dataSet);
    }

    

    renderEditable = cellInfo => {
        const cellValue = this.state.data[cellInfo.index][cellInfo.column.id];
        console.log(this.state.data[cellInfo.index].property_id);
        if (this.state.data[cellInfo.index].property_id === this.props.property_id){
            return cellValue;
        }
        else{
        
        if (cellInfo.column.id == "suburb") {
            
            if (cellValue) {
                console.log(cellValue);
                return (<div><Select
                    value={ { value: cellValue+" ("+cellInfo.original.state+")", label: cellValue+" ("+cellInfo.original.state+")" }  }
                    onChange={this.handleSuburbChange.bind(null, cellInfo)}
                    options={this.props.suburbOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
            else {
                return (<div><Select
                    value={ { value:null, label: null }  }
                    onChange={this.handleSuburbChange.bind(null, cellInfo)}
                    options={this.props.suburbOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
        }
        if (cellInfo.column.id == "cityscope") {
            
            if (cellValue) {
                console.log(cellValue);
                return (<div><Select
                    value={ { value: cellValue, label: cellValue }  }
                    onChange={this.handleCityscopeChange.bind(null, cellInfo)}
                    options={this.props.cityscopeOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
            else {
                return (<div><Select

                    onChange={this.handleCityscopeChange.bind(null, cellInfo)}
                    options={this.props.cityscopeOptions}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                /></div>
                );
            }
        }
        }

        if (cellInfo.column.id.indexOf(["description"]) >= 0 || cellInfo.column.id.indexOf(["title"]) >= 0 || cellInfo.column.id.indexOf(["zoning"]) >= 0) {
            return (
                <Form.Control
                    onChange={this.handleInputChange.bind(null, cellInfo)}
                    onBlur={this.handleSave.bind(null, cellInfo)}
                    type="text"
                    as="textarea"
                    rows={(Math.abs((cellValue||"").length/80)+1).toString()}
                    className="no-border form-control"
                    value={cellValue!=null? cellValue:""}
    
                />
            );
            }

        switch (typeof (cellValue)) {
            case "boolean":
                return (
                    <Form.Check checked={cellValue}
                        onChange={this.handleCheckboxChange.bind(null, cellInfo)}
                        label=""
                        type="checkbox"
                        onBlur={this.handleSave.bind(null, cellInfo)}

                    />);

                    case "number":
                        return (
                            <input
                                onChange={this.handleNumberChange.bind(null, cellInfo)}
                                onBlur={this.handleSave.bind(null, cellInfo)}
                                type="number"
                                className="no-border form-control"
                                value={cellValue!=null? cellValue: " "}
        
                            />
                        );
        
                    default:
                        if (cellInfo.column.id.indexOf("date") >= 0) {
                            return (
                                <DatePicker
                                    selected={cellValue!=null?  new Date(cellValue):""}
                                    onChange={this.handleDateChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    dateFormat="dd/MM/yyyy"
                                    className="no-border form-control"
                                />);
                        }
                        else {
                            return (
                                <input
                                    onChange={this.handleInputChange.bind(null, cellInfo)}
                                    onBlur={this.handleSave.bind(null, cellInfo)}
                                    type="text"
                                    className="no-border form-control"
                                    value={cellValue!=null? cellValue:""}
        
                                />
                            );
                        }

        }
    }

   

    renderTable(data) {
        const columns = [

            {
                id: 'property_id',
                Header: 'Property ID',
                maxWidth: 80,
                accessor: 'property_id',
                Cell: e => <LinkContainer to={`../properties/${e.value}`}><a> {e.value} </a></LinkContainer>
                

        }, {
                id: 'cityscope',
                Header: 'Cityscope',
                accessor: 'Cityscope',
                maxWidth: 75,
                Cell: this.renderEditable,

            }, {
                id: 'map_number',
                Header: 'Map No',
                accessor: 'map_number',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'map_number_suffix',
                Header: 'Map No Suffix',
                accessor: 'map_number_suffix',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'property_number',
                Header: 'Property No',
                accessor: 'property_number',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'property_number_suffix',
                Header: 'Property No Suffix',
                accessor: 'property_number_suffix',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'unit_number',
                Header: 'Unit No',
                accessor: 'unit_number',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'unit_number_suffix',
                Header: 'Unit No Suffix',
                accessor: 'unit_number_suffix',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'unit_sort',
                Header: 'Unit Sort',
                accessor: 'unit_sort',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'description',
                Header: 'Description',
                accessor: 'description',
                maxWidth: 300,
                Cell: this.renderEditable,

            },
            {
                id: 'unit_area',
                Header: 'Area',
                accessor: 'unit_area',
                maxWidth: 90,
                Cell: this.renderEditable,

            },
            {
                id: 'unit_level_number',
                Header: 'Unit Level No',
                accessor: 'unit_level_number',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'bedrooms',
                Header: 'Bedrooms',
                accessor: 'bedrooms',
                maxWidth: 70,
                Cell: this.renderEditable,

            },
            {
                id: 'parking_yes_no',
                Header: 'Parking?',
                accessor: 'parking_yes_no',
                maxWidth: 70,
                Cell: this.renderEditable,
                style: { textAlign: "center" }

            },
            {
                id: 'parking_num',
                Header: 'Parking No',
                accessor: 'parking_num',
                maxWidth: 70,
                Cell: this.renderEditable

            },
           
            // {
            //     id: 'title_details',
            //     Header: 'Title',
            //     accessor: 'title_details',
            //     maxWidth: 100,
            //     Cell: this.renderEditable,

            // },
            {
                id: 'suburb',
                Header: 'Suburb',
                accessor: 'suburb',
                
                Cell: this.renderEditable,

            },  
            {
                id: 'zoning_text',
                Header: 'Zoning',
                accessor: 'zoning_text',
                maxWidth: 100,
                Cell: this.renderEditable,

            },
            {
                Header: '',
                accessor: 'property_id',
                maxWidth: 65,
                Cell: row => <Button type="button" size="sm" variant="primary" onClick={(e) => this.handleCopyRecord(row,e)}>Copy</Button>
            }
        ]

        if (!data) {
            return null
        }
        else {
            return (
                <div>
             
                <ReactTable
                    data={data}
                    columns={columns}
                    defaultPageSize={10}
                    sortable={false}
                    />
                    </div>
            )
        }



    }

    //Modify the attribute shown in the list for each type of record
    renderList(data) {
        if (!data) {
            return null
        }
        else {
            return [{}].concat(data).map(
                (d, i) =>
                    i !== 0
                        ? <LinkContainer key={i} to={`/properties/${d.property_key}`}>
                            <ListGroup.Item key={i} as="a" header={d.property_key}>
                                {d.property_key}
                            </ListGroup.Item>
                        </LinkContainer>
                        : ""
            );
        }
    }


    
    renderComponent() {
        return (
            <div className="PropertyData">
                <Modal show={this.state.showAlert} onHide={(e)=>{this.setState({showAlert: !this.state.showAlert})}} centered >
                    <Modal.Header closeButton> <Modal.Title>Uh Oh!</Modal.Title></Modal.Header>
                    <Modal.Body > <Alert variant="danger"  >{this.state.errorMessage}</Alert> </Modal.Body>
                </Modal>
                {(this.props.controlType === "table" || this.props.controlType === "table2") && <Row >
                    <Col className="text-right" >
                        
                        
                        {/* {this.props.controlType === "table" && <Button variant="secondary" size="sm" onClick={this.addRecord}>Add</Button>} */}

                    </Col>
                </Row>}

                    <Row className="show-Container">
                        <Col sm={12} md={12} lg={12}>
                        {!this.state.isLoading && this.props.controlType == "table" ? this.renderTable(this.state.data) : this.renderList(this.state.data)}
                        </Col>
                    </Row>
        

            </div>
        );
    }
  render() {
    return (

        <div className="PropertyAddSection">
            {this.props.isAuthenticated ? this.renderComponent() : console.log("error)")}
        </div>
    );
  }
}
